<template>
  <div>
    <masonry :cols="cols" :gutter="{ default: '15px' }"
      class="masonry">
      <project-tile v-if="projects" v-for="project in projects" :project="project" :key="project.id"></project-tile>
    </masonry>
    <div class="load-more-wrapper">
      <b-button v-if="hasMore" variant="primary" class="w-100" @click="loadMore">
        {{ $t('messages.load_more') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import ProjectTile from '../../components/project/ProjectTile'

import { defaultMixin } from '../../mixin/default'
import { projectMixin } from '../../mixin/project'
import { navigationMixin } from '../../mixin/navigation'

import { projectService } from '../../services/project.service'

Vue.use(VueMasonry)

export default {
  name: 'projectdashboard',
  mixins: [ defaultMixin, projectMixin, navigationMixin ],
  components: { ProjectTile },
  data: function () {
    return {
      cols: {
        default: 6,
        1600: 5,
        1300: 4,
        1000: 2,
        700: 1
      },
      rows: 4,
      params: {
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1
      },
      hasMore: false,
      projects: [],
      initialized: false
    }
  },
  methods: {
    fetchProjects: function () {
      let size = null
      let screenWidth = window.innerWidth
      for (let key in this.cols) {
        if (size === null) {
          if (key !== 'default' && screenWidth <= key) {
            size = this.cols[key]
          } else if (key === 'default') {
            size = this.cols[key]
          }
        }
      }
      size = size * this.rows

      let loader = this.$loading.show()
      let store = this.$store
      let filter = {
        page: this.initialized ? this.params.page : 1,
        size: this.initialized ? size : (this.params.page * size),
        search: store.state.search,
        lat: store.state.lat,
        lng: store.state.lng,
        distance: store.state.distance
      }

      projectService.fetch(filter)
        .then((projects) => {
          if (this.params.page === 1) {
            this.projects = projects
          } else {
            this.projects = this.projects.concat(projects)
          }
          this.hasMore = projects.length === (this.initialized ? size : (this.params.page * size))
          loader.hide()
          if (!this.initialized) {
            this.$store.commit('moveToScrollPosition')
          }
          this.initialized = true
        }, () => {
          store.commit('error', 'errors.projects')
          loader.hide()
        })
    },
    loadMore: function () {
      this.params.page += 1
      this.load()
    },
    resetAndLoad: function () {
      this.params.page = 1
      this.load()
    },
    load: function () {
      let params = this.params
      let query = this.generateQueryParams(params)
      this.pushUrlState(query)
      this.fetchProjects()
    }
  },
  created: function () {
    this.fetchProjects()
    this.$root.$on('searchProjects', () => {
      this.hasMore = false
      this.params.page = 1
      this.projects = []
      this.fetchProjects()
      this.$root.$emit('updateNavigationLocation')
    })
  },
  beforeDestroy: function () {
    this.$root.$off('searchProjects')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .masonry {
    padding: 10px;
  }

  .load-more-wrapper {
    margin-top: -20px;
    padding: 0px 10px 10px;
  }

  .no-decoration {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/ProjectDashboard.vue